import { z } from 'zod'

export const ChartItem = z.object({
  count: z.number(),
  label: z.string(),
})
export type ChartItem = z.infer<typeof ChartItem>;

export const TimeRange = z.enum(['ALL_TIME', 'PAST_7_DAYS', 'PAST_30_DAYS', 'PAST_90_DAYS', 'PAST_YEAR'])
export type TimeRange = z.infer<typeof TimeRange>;


export const BarChartDataItem = z.record(z.string(), z.union([z.string(), z.number()]));
export type BarChartDataItem = z.infer<typeof BarChartDataItem>;